module.exports = __webpack_public_path__ + "static/media/completed-step-icon.3d91ce88.svg";